module.exports = __webpack_public_path__ + "static/media/404bg.7d2ffd7e.jpg";